module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/assessment_achievements/5_008d3e7cbbcab861d8a764eb6d9b0dc8.jpg";